module.exports = "<div gw-pl-binary-choice model=\"model\" label=\"{{label}}\"\r\n     title-left=\"{{'platform.inputs.Yes' | translate}}\"\r\n     title-right=\"{{'platform.inputs.No' | translate}}\"\r\n     value-left=\"true\"\r\n     value-right=\"false\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/customer/js/src/edge/platform/widgets/inputs/templates/yes-no.html
// module id = 419
// module chunks = 0